import { useState, useEffect, useRef } from 'react';
import api from '../../api';

// Ricerca di un cliente dello studio per nome, codice fiscale o codice azienda parcellazione.
// Il cliente si sceglie sempre dall'anagrafica: il testo digitato serve solo a cercare.
// `url`: elenco da cui cercare (clienti di Parcellazione o ditte dello Scadenziario: stessa anagrafica)
export default function ClienteRicerca({ onSeleziona, placeholder = 'Cerca azienda…', onNuovo, autoFocus, valore, url = '/competenze/clienti' }) {
  const [testo, setTesto] = useState(valore?.ragione_sociale || '');
  const [risultati, setRisultati] = useState([]);
  const [aperto, setAperto] = useState(false);
  const [evidenziato, setEvidenziato] = useState(0);
  const timer = useRef();

  useEffect(() => { setTesto(valore?.ragione_sociale || ''); }, [valore]);

  useEffect(() => {
    clearTimeout(timer.current);
    if (!aperto) return undefined;
    timer.current = setTimeout(() => {
      api.get(url, { params: { cerca: testo.trim() || undefined } })
        .then(r => { setRisultati(r.data.slice(0, 50)); setEvidenziato(0); })
        .catch(() => setRisultati([]));
    }, 200);
    return () => clearTimeout(timer.current);
  }, [testo, aperto, url]);

  const scegli = (c) => {
    onSeleziona(c);
    setAperto(false);
    if (!valore) setTesto('');
  };

  const tasto = (e) => {
    if (!aperto) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setEvidenziato(i => Math.min(i + 1, risultati.length - 1)); }
    if (e.key === 'ArrowUp') { e.preventDefault(); setEvidenziato(i => Math.max(i - 1, 0)); }
    if (e.key === 'Enter' && risultati[evidenziato]) { e.preventDefault(); scegli(risultati[evidenziato]); }
    if (e.key === 'Escape') setAperto(false);
  };

  return (
    <div style={styles.box}>
      <input
        type="text"
        value={testo}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={e => { setTesto(e.target.value); setAperto(true); }}
        onFocus={() => setAperto(true)}
        onBlur={() => setTimeout(() => setAperto(false), 150)}
        onKeyDown={tasto}
        style={styles.input}
        aria-label="Azienda"
      />
      {aperto && (
        <div style={styles.lista} role="listbox">
          {risultati.map((c, i) => (
            <div
              key={c.id}
              role="option"
              aria-selected={i === evidenziato}
              onMouseDown={() => scegli(c)}
              style={{ ...styles.voce, ...(i === evidenziato ? styles.voceAttiva : {}) }}
            >
              {(c.codice_azienda ?? c.codice_ditta_paghe) && <span style={styles.codici}>{c.codice_azienda ?? c.codice_ditta_paghe} · </span>}
              {c.ragione_sociale}
            </div>
          ))}
          {risultati.length === 0 && <div style={styles.vuoto}>Nessuna azienda trovata</div>}
          {onNuovo && (
            <div onMouseDown={() => { setAperto(false); onNuovo(testo); }} style={styles.nuovo}>{'+ Nuova azienda'}{testo ? ` "${testo}"` : ''}</div>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  box: { position: 'relative', width: '100%' },
  input: { width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.9rem', boxSizing: 'border-box' },
  lista: { position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '6px', boxShadow: '0 6px 18px rgba(0,0,0,0.12)', zIndex: 50, maxHeight: '280px', overflowY: 'auto', marginTop: '2px' },
  voce: { padding: '0.45rem 0.6rem', cursor: 'pointer', fontSize: '0.88rem' },
  voceAttiva: { background: '#F7F7EA' },
  codici: { color: '#888', fontSize: '0.78rem' },
  vuoto: { padding: '0.5rem 0.6rem', color: '#999', fontSize: '0.85rem' },
  nuovo: { padding: '0.5rem 0.6rem', cursor: 'pointer', fontSize: '0.85rem', borderTop: '1px solid #eee', color: '#232323', fontWeight: 600 },
};
